import AlertItem from './alert-item';

export default AlertItem;
